import { useEffect, useState } from "react";

/** A picture chosen BEFORE the record exists (creation): held as a blob and
 *  uploaded right after the create succeeds — the driver-invite pattern.
 *
 *  Use this instead of calling `URL.createObjectURL(blob)` inline in JSX. An
 *  inline call mints a NEW object URL on every render and never revokes it, so
 *  a form that re-renders per keystroke leaks one full-size blob per keystroke
 *  until the page unloads. The effect below revokes on change and on unmount.
 */
export function useStagedImage() {
  const [blob, setBlob] = useState<Blob | null>(null);
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!blob) { setUrl(null); return; }
    const u = URL.createObjectURL(blob);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [blob]);
  return { blob, url, set: setBlob };
}
